import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { peicarLogoSVG } from "../../Assets/Images";
import { InputText } from "primereact/inputtext";
import { set, useForm } from "react-hook-form";
import axios from "axios";
import { url } from "../../env";
import { ModalGraLoginlCss } from "./ModalGralLogin.css.js";

export default function ModalGral({ setShowModal, showModal, toast, email, setLoading }) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
    reset, // Agregado para reiniciar el formulario
  } = useForm({
    defaultValues: {
      email: email ? email : "",
    },
  });

  const [message, setMessage] = useState(""); // Estado para el mensaje
  const [messageType, setMessageType] = useState(""); // Estado para el tipo de mensaje (success o error)

  const handleOnChange = (e) => {
    setValue("email", e.target.value);
  };

  const handleRecuperarContrasena = () => {
    const email = getValues("email");
    const resetPasswordUrl = window.location.href; // Obtiene la URL completa
    
    setLoading(true);
    axios.post(`${url}/password/email`, {
      email: email, // Cambiado para usar el email ingresado
      reset_password_url: resetPasswordUrl,
    }).then((response) => {
      setLoading(false);
      if (response.status === 200) {
        setMessage("Revisa tu correo para recuperar tu contraseña");
        setMessageType("success");
        reset(); // Limpia los campos del formulario
        toast.current.show({
          severity: "success",
          summary: "Correo enviado",
          detail: "Revisa tu correo para recuperar tu contraseña",
          life: 3000,
        });
      } else {
        setMessage("No se pudo enviar el correo");
        setMessageType("error");
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo enviar el correo",
          life: 3000,
        });
      }
    }).catch((error) => {
      setLoading(false);
      setMessage("Ocurrió un error. Intenta nuevamente.");
      setMessageType("error");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ocurrió un error. Intenta nuevamente.",
        life: 3000,
      });
    });
  };

  return (
    <div css={ModalGraLoginlCss}>
      <div className="Modal card flex justify-content-center"
        style={{ boxShadow: "1px 1px 1px black" }}>

        <Dialog
          visible={true}
          onHide={() => { if (!showModal) return; setShowModal(false); }}
          draggable={false}
          style={{ width: "50vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          header={
            <div className="header-with-image flex mb-0 relative"
              style={{ padding: "1rem", justifyContent: "center",
                zIndex: "10"
               }}
            >
              <h2
                style={{
                  background:
                    "linear-gradient(90deg, #34C6F1 6.22%, #1FDD8F 77.34%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Recupera tu contraseña
              </h2>
              <button
                onClick={() => { setShowModal(false); }}
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '0px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '15px',
                  color: '#828282',
                }}
              >
                ✖️
              </button>
            </div>
          }
        >
          <p
            style={{
              color:"#204b7b",
              marginBottom: "1rem",
              fontSize: "calc(0.6rem + 0.9vw)",
            }}
          >
            ! Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña !
          </p>
          <form onSubmit={handleSubmit(handleRecuperarContrasena)}>
            <InputText
              maxLength={40}
              {...register("email", {
                required: true,
                pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/,
                maxLength: 40,
              })}
              onChange={handleOnChange}
              placeholder="Correo electrónico"
              className={`EmailInput w-full TextInput ${errors.email ? "p-invalid" : ""}`}
            />
            {message && (
              <p className={`mt-2 ${messageType === "success" ? "text-green-600" : "text-red-600"}`}>
                {message}
              </p>
            )}
            <Button
              label="Enviar"
              className="w-full py-3"
              style={{
                display: 'inline-block',
                outline: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                lineHeight: '20px',
                fontWeight: '600',
                borderRadius: '8px',
                padding: '10px 18px',
                border: '1px solid #34C6F1',
                transition: 'box-shadow 0.2s ease, transform 0.1s ease',
                background: '#34C6F1',
                color: 'white',
                marginTop: '1rem',
              }}
              type="submit"
            />
          </form>
        </Dialog>

      </div>
    </div>
  );
}
